import React from 'react';
import { UserShowcasePageType } from '../../../lib/api/custom-page.types';
import { EmbedContainer } from '../../../lib/kv-embed';
import { arePageFlagsPending, useEventSettings } from '../../../lib/context-providers/event-settings-context/event-settings-context';

export const ShowcaseCustomPage: React.FunctionComponent<UserShowcasePageType> = (props: UserShowcasePageType): JSX.Element | null => {
  const eventSettings = useEventSettings();
  if (arePageFlagsPending(eventSettings)) return null;

  if (props && props.embedCodeId) return <EmbedContainer.Showcase embedId={props.embedCodeId} />;
  return null;
};
